var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBombSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5001 7L18.7931 5.707C19.0172 5.48283 19.195 5.2167 19.3163 4.92382C19.4376 4.63093 19.5001 4.31702 19.5001 4C19.5001 3.73478 19.6054 3.48043 19.793 3.29289C19.9805 3.10536 20.2348 3 20.5001 3H21.5001M7.50006 13C7.50006 12.2044 7.81613 11.4413 8.37874 10.8787C8.94135 10.3161 9.70441 10 10.5001 10M19.1501 8.65001C19.2616 8.76145 19.3501 8.8938 19.4105 9.03948C19.4709 9.18516 19.502 9.34131 19.502 9.49901C19.502 9.65671 19.4709 9.81286 19.4105 9.95854C19.3501 10.1042 19.2616 10.2366 19.1501 10.348L18.1781 11.32C18.6634 12.92 18.6002 14.6364 17.9984 16.1963C17.3967 17.7563 16.2909 19.0705 14.8567 19.9301C13.4226 20.7896 11.7423 21.1454 10.0829 20.9407C8.42345 20.736 6.87998 19.9827 5.69769 18.8004C4.51539 17.6181 3.76207 16.0746 3.55739 14.4152C3.35272 12.7557 3.70842 11.0755 4.56801 9.64134C5.42759 8.20719 6.74175 7.10141 8.30173 6.49965C9.86171 5.89789 11.578 5.83466 13.1781 6.32001L14.1501 5.34801C14.2615 5.23644 14.3939 5.14792 14.5395 5.08754C14.6852 5.02715 14.8414 4.99606 14.9991 4.99606C15.1568 4.99606 15.3129 5.02715 15.4586 5.08754C15.6043 5.14792 15.7366 5.23644 15.8481 5.34801L19.1501 8.65001Z",
    stroke: "#0062f5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBombSelected);
export default __webpack_public_path__ + "static/media/bomb-selected.d48c4c1fe7fc1b860b2a753dcbed0c0d.svg";
export { ForwardRef as ReactComponent };